import dayjs from 'dayjs'
import { LOCALE, ScheduleEventCard } from 'interfaces/types'
import { DATE_FORMAT_API, ScheduleEventStatus } from './context'
import { format } from 'date-fns'
import { DATE_FNS_LOCALE } from '@hhgtech/hhg-components/constants'

export function getState(startDate: Date, endDate: Date) {
  return dayjs().isAfter(endDate)
    ? ScheduleEventStatus.LIVED
    : dayjs().isBetween(startDate, endDate)
    ? ScheduleEventStatus.LIVE
    : ScheduleEventStatus.NOT_YET
}

export function formatCard(
  listEvent: ScheduleEventCard[] = [],
  locale: LOCALE,
) {
  return listEvent.map((i, index) => {
    const curState = getState(
      dayjs(i.startDate, DATE_FORMAT_API).toDate(),
      dayjs(i.endDate, DATE_FORMAT_API).toDate(),
    )
    const item = {
      ...i,
      state: curState,
      title: format(
        dayjs(i.startDate, DATE_FORMAT_API).toDate(),
        'HH:mm - eeee, dd.MM.YYY',
        {
          locale: DATE_FNS_LOCALE[locale as keyof typeof DATE_FNS_LOCALE],
        },
      ),
      episode: index + 1,
    }
    return item
  })
}

export function groupByMonth(listEvent: ScheduleEventCard[]) {
  const group: { [key in string]: ScheduleEventCard[] } = {}
  // const group: {month: string, item: ScheduleEventCard[]}[] = []
  listEvent.map((i) => {
    const curMonth = dayjs(i.startDate, DATE_FORMAT_API).format('MM-YYYY')
    const newItem = {
      ...i,
      monthKey: curMonth,
    }
    if (Object.keys(group).includes(curMonth)) {
      const curList = group[curMonth] || []
      group[curMonth] = [...curList, newItem]
    } else {
      group[curMonth] = [newItem]
    }
  })
  return group
}

export function groupByStatus(listEvent: ScheduleEventCard[]) {
  const group: { [key in ScheduleEventStatus]?: ScheduleEventCard[] } = {}
  listEvent.map((i) => {
    const curState = i.state
    if (curState) {
      if (Object.keys(group).includes(curState)) {
        const curList = group[curState] || []
        group[curState] = [...curList, i]
      } else {
        group[curState] = [i]
      }
    }
  })
  return group
}

export function hasCommingCountdown(item: ScheduleEventCard) {
  if (!item || !item.countdownStart) return false
  const countdownStart = dayjs(item.countdownStart, DATE_FORMAT_API).toDate()
  return (
    item.state === ScheduleEventStatus.NOT_YET &&
    dayjs().isAfter(countdownStart)
  )
}

export function getUpcommingEvents(listEvent: ScheduleEventCard[]) {
  // return listEvent.find(
  //   (i) => i.state === ScheduleEventStatus.LIVE || hasCommingCountdown(i),
  // )
  return listEvent.filter(
    (i) =>
      i.state === ScheduleEventStatus.LIVE ||
      i.state === ScheduleEventStatus.NOT_YET,
  )
}

export function findNextEvent(
  currentEvent: ScheduleEventCard,
  listEvent: ScheduleEventCard[],
) {
  const curIdx = listEvent.findIndex((i) => i.id === currentEvent.id)
  return listEvent[curIdx]
}

export function checkIsCurrentMonth(month: string) {
  return Number(month) === Number(dayjs().format('MM'))
}
